import { render, staticRenderFns } from "./PlanBenefits.vue?vue&type=template&id=2f3b42ae&"
import script from "./PlanBenefits.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlanBenefits.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PlanBenefits.vue?vue&type=style&index=0&id=2f3b42ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports